// @flow
import axios from "axios";
import types from "./types";
import {Next} from "../MiddlewareUtils";
import type {Store as ReduxStore} from "redux";
import AppOperations from "../../Ducks/App/operations";
import type {Action} from "../../Ducks/DucksUtils";
import { BACKEND_BASE_URL } from "../../../config";

const backendRequestHeaders = {"Content-Type": "application/json"};
const backendConnection = axios.create({
    baseURL: `${BACKEND_BASE_URL}/rider/app`,
    headers: backendRequestHeaders,
});

export const backendRequest = async function (url: string, requestObject: Object) {
    let JSONRequestString = JSON.stringify(requestObject);
    return await backendConnection.post(url, JSONRequestString);
};

const addAccountDetailsToRequest = (body, tokenData) => {
    let requestWithAccountDetails = {...tokenData, ...body};
    requestWithAccountDetails.rider_details = {
        "first_name": tokenData.first_name,
        "last_name": tokenData.last_name,
        "email": tokenData.email,
        "phone_number": tokenData.phone_number,
    };
    return requestWithAccountDetails;
};


const apiBusinessError = 409,
    pageNotFoundError = 404,
    internalServerError = 500,
    missingArgumentError = 400,
    forbiddenError = 403;
const errorCodes = [apiBusinessError, pageNotFoundError, internalServerError, missingArgumentError, forbiddenError];
const isResponseValid = (data, statusText) => {
    if (!data) {
        return false;
    }
    if (errorCodes.indexOf(data.status_code) >= 0 || data.errno) {
        return false;
    }
    if (statusText && statusText.indexOf("error") >= 0) {
        return false;
    }
    return true;
};

const dispatchListOfActions = (actions, handlerPerAction) => {
    if (!Array.isArray(actions)) {
        actions = [actions];
    }
    actions.map(handlerPerAction);
};

const middleware = (store: ReduxStore) => (next: Next) => (action: Action) => {
    const dispatch = store.dispatch;
    const getState = store.getState;

    if (!action || action.type !== types.API_POST) {
        return next(action);
    }

    let {url, body = {}, success = [], error, beforeActions, finallyActions, showLoading = false} = action.payload;
    const newBody = addAccountDetailsToRequest(body, getState().tokenData);

    showLoading && dispatch(AppOperations.loadingSemaphoreIncrement());

    beforeActions && dispatchListOfActions(beforeActions, beforeAction => dispatch(beforeAction()));

    return backendRequest(url, newBody)
        .then(({data, status, statusText}) => {
            if (!isResponseValid(data, statusText)) {
                throw data;
            }
            dispatchListOfActions(success, successHandler => dispatch(successHandler(data)));
        })
        .catch(e => {
            if (error) {
                dispatchListOfActions(error, errorHandler => dispatch(errorHandler(e)));
            } else {
                console.info(url, body, `encountered an error`, e);
            }

        })
        .then(() => {
            showLoading && dispatch(AppOperations.loadingSemaphoreDecrement());
            finallyActions && dispatchListOfActions(finallyActions, finallyAction => dispatch(finallyAction()));
        });
};
export default middleware;



// WEBPACK FOOTER //
// ./src/Store/Middleware/Backend/middleware.js